module.exports = __webpack_public_path__ + "static/img/defender5.29cc46f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/defender5.png
// module id = 8FfR
// module chunks = 0